export enum ModalWidthSize {
  SM = 'sm',
  LG = 'lg',
  MD = 'md',
  NONE = 'none',
  XL = 'xl'
}
